<template>
    <van-popup v-if="projectProgressPopupShow " :value="projectProgressPopupShow" z-index="100" :close-on-click-overlay="false"
               :style="{ height: '100vh',width: '100vw', background: 'rgba(0,0,0,.3)' }" overlay-class="custom_popup" position="right">
        <div class="project_progress_wrap" v-loading="loading">
            <div class="project_progress_top">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft" @click="handleClickClose">
                        <van-icon  name="arrow-left" />
                        <span class="normal_title">返回</span>
                    </div>
                    <ul class="project_list_type_list">
                       <li :class="{'active':listMode==='time_axis'}" class="project_list_type_item"  @click="handleClickProjectListType('time_axis')">
                           <i class="iconfont icon-shijianzhou"></i>
                           <span>时间轴</span>
                       </li>
                       <li :class="{'active':listMode==='gantt_chart'}" class="project_list_type_item"  @click="handleClickProjectListType('gantt_chart')">
                           <i class="iconfont icon-gantetu"></i>
                           <span>甘特图</span>
                       </li>
                    </ul>
                </div>

            </div>
            <div class="project_progress_bottom">
                <div class="project_progress_time_axis" v-if="listMode==='time_axis'">
                    <div class="project_progress_time_axis_top">
                        <span @click="handleClickAddProjectRecord" class="link-label"><i class="iconfont icon-tianjia1 mr_4"></i>新增记录</span>
                    </div>
                    <div class="project_progress_time_axis_bottom">
                        <ul>
                            <li>
                                <div class="record_time">
                                    <div class="time"></div>
                                    <span></span>
                                </div>
                                <div class="record_content">
                                    <div class="record_item">开始</div>
                                </div>
                            </li>
                            <li v-for="item in logList">
                                <div class="record_time">
                                    <div class="time" v-text="item.date"></div>
                                    <span></span>
                                </div>
                                <div class="record_content">
                                    <div class="record_item" v-for="log in item.logs">
                                        <div v-if="log.type == 'custom'">
                                            <span v-html="log.user.name + '：' + log.content.text + updatedDate(item.date,log.updated_at)"></span>
                                            <i @click="handleClickRecord(log)" class="iconfont icon-bianji ml_4"></i>
                                        </div>
                                        <div v-else>
                                            <span v-text="getLogDescriptions(log).title"></span>
                                            <span @click="handleClickRelateHandle(getLogDescriptions(log).handle_type,getLogDescriptions(log).info)" class="link-label" v-text="getLogDescriptions(log).relate_num"></span>
                                            <span v-text="getLogDescriptions(log).content_text"></span>
                                            <span class="link-label" v-if="getLogDescriptions(log).derivative_num" v-text="getLogDescriptions(log).derivative_num" @click="handleClickRelateHandle(getLogDescriptions(log).derivative_handle_type,getLogDescriptions(log).derivative)"></span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="record_time">
                                    <div class="time"></div>
                                    <span></span>
                                </div>
                                <div class="record_content">
                                    <div class="record_item"  v-if="projectDetail.status == 1">完结</div>
                                    <div class="record_item"  v-if="projectDetail.status == 2">关闭</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="project_progress_gantt_chart" v-if="listMode==='gantt_chart'">

                </div>
            </div>


            <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }" z-index="1000" v-if="handleRadioPicker" :show="handleRadioPicker" @click="handleRadioPicker = false" >
                <div class="custome_radio_option_wrap">
                    <ul class="radio_option_list">
                        <li class="radio_option_item"  @click="handleClickEditProjectRecord()">编辑记录</li>
                        <li class="radio_option_item"  @click="handleClickDelProjectRecord()">删除</li>

                    </ul>
                    <div class="cancel_btn" @click="handleRadioPicker = false">取消</div>
                </div>
            </van-overlay>

            <RecordTpl v-if="recordAddEditPopupShow" :recordAddEditPopupShow.sync="recordAddEditPopupShow" :projectId="projectId" :recordId="recordId" @success="getProjectLogList"/>

            <!--相关关联的操作-->
            <RelatedHandle ref="relatedHandle" @relatedHandleSuccess="relatedHandleSuccess"/>
        </div>
    </van-popup>
</template>

<script>
import {ProjectLogList,ProjectLogDel} from "@/api/index.js"
import RecordTpl from "./record_tpl"
import RelatedHandle from "./related_handle.vue";
import {Dialog} from "vant";
export default {
    name: "project_progress",
    components: {RecordTpl,RelatedHandle},
    props: {
        projectProgressPopupShow: {
            type: Boolean,
            default: false
        },
        projectId: {
            type: [String, Number],
            default: '0'
        },
        projectDetail: {
            type: Object,
            default: () => {}
        },

    },
    data() {
        return {
            defaultImg: require('@/assets/images/default.jpg'),
            loading:false,
            listMode:'time_axis',
            logList:[],
            handleRadioPicker:false,
            recordId:0,
            recordAddEditPopupShow:false,
        };
    },

    created() {
        this.getProjectLogList()
    },
    methods: {
        // 获取项目进度列表
        getProjectLogList(){
            this.loading = true
            let postData = {
                id: this.projectId,
            }
            ProjectLogList(postData).then(res => {
                if (res.code === 200) {
                    this.logList  = res.data || []
                    this.loading = false
                }
            })
        },
        handleClickRecord(log){
            this.recordId = log.log_id
            this.handleRadioPicker = true
        },
        // 新增记录
        handleClickAddProjectRecord(){
            this.recordId = 0
            this.recordAddEditPopupShow = true
        },
        // 编辑记录
        handleClickEditProjectRecord(){
            this.recordAddEditPopupShow = true
        },
        // 删除记录
        handleClickDelProjectRecord(){
            Dialog.confirm({
                title: "删除记录",
                message: "确定要删除吗？",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            })
            .then(() => {
                ProjectLogDel({id:this.recordId}).then(res => {
                    if (res.code === 200) {
                        this.$toast({
                            message: '删除成功',
                            type: "success",
                            duration: 1000,
                            onClose: () => {

                            },
                        });
                        this.getProjectLogList()
                    }
                })
            })
            .catch(() => { });
        },
        handleClickProjectListType(mode){
            this.listMode = mode
        },
        handleClickClose(){
            this.$emit("update:projectProgressPopupShow", false)
        },

        // 关联的功能操作
        handleClickRelateHandle(type,data){
            this.$refs.relatedHandle.projectId = this.projectId
            this.$refs.relatedHandle.projectDetail = this.projectDetail
            this.$refs.relatedHandle.handleClickRelateHandle(type,data)
        },
        // 关联的操作回调
        relatedHandleSuccess(data){

        },
        // 日期对比
        updatedDate(date,logTime){
            let time = logTime.split(' ')[0]
            if(date != time){
                return `（${time}）`
            }else{
                return ''
            }
        },
        // 日志映射
        getLogDescriptions(log){
            let data = null
            switch (log.type) {
                case "project_add":
                    data = {
                        title:'新建商机：',
                        handle_type:'business_detail',
                        relate_num:log.content ? log.content.project_name :'',
                        content_text:'',
                        info:{project_id:log.relate_id, name:log?.content?.project_name}
                    }
                    break;  //新增商机
                case "project_relate":
                    data = {
                        title:'关联商机：',
                        handle_type:'business_detail',
                        relate_num:log.content ? log.content.project_name :'',
                        content_text:'',
                        info:{project_id:log.relate_id, name:log?.content?.project_name}
                    }
                    break; //关联商机
                case "project_push":
                    data = {
                        title:'商机：',
                        handle_type:'business_detail',
                        relate_num:log.content ? log.content.project_name :'',
                        content_text:`已推进至“${log.content?.project_stage_name}”阶段`,
                        info:{project_id:log.relate_id, name:log?.content?.project_name}
                    }
                    break; //商机推进
                case "project_add_quotation":
                    data = {
                        title:'商机：',
                        handle_type:'business_detail',
                        relate_num:log.content ? log.content.project_name :'',
                        content_text:`新增报价`,
                        info:{project_id:log.relate_id, name:log?.content?.project_name},
                        derivative_num:log.content?.project_quotation_num,  //衍生编号
                        derivative_handle_type:'view_the_quotation', //衍生操作type
                        derivative:{  //衍生信息
                            project_quotation_id:log.content?.project_quotation_id,
                            title:log.content?.project_quotation_num,
                        }
                    }
                    break; //商机新增报价

                case "order_add":
                    data = {
                        title:'新建订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:'',
                        info:{order_id:log.relate_id, order_no:log.relate_num}
                    }
                    break; //新增订单
                case "order_relate":
                    data = {
                        title:'关联订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:'',
                        info:{order_id:log.relate_id, order_no:log.relate_num}
                    }
                    break; //关联订单
                case "order_edit":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-订单编辑`,
                        info:{order_id:log.relate_id, order_no:log.relate_num}
                    }
                    break;//订单编辑
                case "order_stock_edit_out":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-订单编辑-出库`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.out_num,  //衍生编号
                        derivative_handle_type:'out_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            out_num:log.content?.out_num,
                            id:log.content?.out_id,
                        }
                    }
                    break;//订单编辑


                case "order_rent_to_sale":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-租借转销售`,
                        info:{order_id:log.relate_id, order_no:log.relate_num}
                    }
                    break;//售后-租借转销售
                case "order_purchase":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`新增代采，代采编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.purchase_num,  //衍生编号
                        derivative_handle_type:'order_purchase_detail', //衍生操作type
                        derivative:{  //衍生信息
                            purchase_num:log.content?.purchase_num,
                            id:log.content?.purchase_id,
                        }
                    }
                    break;//订单代采
                case "order_invoice":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`新建开票${log.content?.invoice_price}，开票编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.invoice_num,  //衍生编号
                        derivative_handle_type:'invoice_detail', //衍生操作type
                        derivative:{  //衍生信息
                            invoice_no:log.content?.invoice_num,
                        }
                    }
                    break;//订单发起开票
                case "order_repay":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`新建回款${log.content?.repay_price}，回款编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.repay_num,  //衍生编号
                        derivative_handle_type:'payment_detail', //衍生操作type
                        derivative:{  //衍生信息
                            receivable_no:log.content?.repay_num,
                        }
                    }
                    break; //订单发起回款
                case "order_return":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-归还`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                    }
                    break;//订单归还
                case "order_stock_out":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`已出库，出库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.out_num,  //衍生编号
                        derivative_handle_type:'out_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            out_num:log.content?.out_num,
                            id:log.content?.out_id,
                        }
                    }
                    break;//订单出库
                case "order_stock_returned_in":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`售后退货已入库，入库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.in_num,  //衍生编号
                        derivative_handle_type:'in_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            in_num:log.content?.in_num,
                            id:log.content?.in_id,
                        }
                    }
                    break;//订单退货入库
                case "order_stock_return_in":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`订单归还已入库，入库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.in_num,  //衍生编号
                        derivative_handle_type:'in_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            in_num:log.content?.in_num,
                            id:log.content?.in_id,
                        }
                    }
                    break;//订单归还入库
                case "order_stock_replace_in":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`订单损坏换新已入库，入库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.in_num,  //衍生编号
                        derivative_handle_type:'in_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            in_num:log.content?.in_num,
                            id:log.content?.in_id,
                        }
                    }
                    break; //订单损坏换新入库
                case "order_stock_replace_out":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`订单损坏换新已出库，出库单编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.out_num,  //衍生编号
                        derivative_handle_type:'out_record_detail', //衍生操作type
                        derivative:{  //衍生信息
                            out_num:log.content?.out_num,
                            id:log.content?.out_id,
                        }
                    }
                    break; //订单损坏换新出库
                case "order_return_goods":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-退货`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        // derivative_num:log.content?.out_num,  //衍生编号
                        // derivative_handle_type:'out_record_detail', //衍生操作type
                        // derivative:{  //衍生信息
                        //     out_num:log.content?.out_num,
                        //     id:log.content?.out_id,
                        // }
                    }
                    break;//订单退货

                case "order_renew":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-续租`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                    }
                    break; //订单续租
                case "order_replace":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-损坏换新`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                    }
                    break;  //订单损坏换新
                case "order_refund":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`发起售后-退款`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                    }
                    break;  //订单退款
                case "stock_out":
                    data = {
                        title:`普通出库：出库编号`,
                        handle_type:'out_record_detail',
                        relate_num:`${log.relate_num}`,
                        content_text:'',
                        info:{id:log.relate_id}
                    }
                    break; //普通出库
                case "stock_in":
                    data = {
                        title:`普通人库：入库编号`,
                        handle_type:'in_record_detail',
                        relate_num:`${log.relate_num}`,
                        content_text:'',
                        info:{id:log.relate_id}
                    }
                    break; //普通入库

                case "finance_bad_debt":
                    data = {
                        title:'订单：',
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`坏账金额${log.content?.bad_price}`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:'详情',  //衍生编号
                        derivative_handle_type:'finance_bad_debt_detail', //衍生操作type
                        derivative:{  //衍生信息
                            related_num:log.relate_num,
                        }
                    }
                    break;//订单坏账
                case "finance_repay_confirm":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`回款${log.content?.repay_price}已确认，回款编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.repay_num,  //衍生编号
                        derivative_handle_type:'payment_detail', //衍生操作type
                        derivative:{  //衍生信息
                            receivable_no:log.content?.repay_num,
                        }
                    }
                    break; //财务回款确认
                case "finance_repay_void":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`回款${log.content?.void_price}已作废，回款编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.void_num,  //衍生编号
                        derivative_handle_type:'payment_detail', //衍生操作type
                        derivative:{  //衍生信息
                            receivable_no:log.content?.void_num,
                        }
                    }
                    break; //回款作废
                case "finance_order_invoice":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`开票${log.content?.invoice_price}已确认，开票编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.invoice_num,  //衍生编号
                        derivative_handle_type:'invoice_detail', //衍生操作type
                        derivative:{  //衍生信息
                            invoice_no:log.content?.invoice_num,
                        }
                    }
                    break; //财务确认开票
                case "finance_order_refund":
                    data = {
                        title:`订单`,
                        handle_type:'order_detail',
                        relate_num:log.relate_num,
                        content_text:`退款${log.content?.refund_price}已确认，应付编号`,
                        info:{order_id:log.relate_id, order_no:log.relate_num},
                        derivative_num:log.content?.payable_no,  //衍生编号
                        derivative_handle_type:'payable_detail', //衍生操作type
                        derivative:{  //衍生信息
                            id:log.content?.payable_no,
                        }

                    }
                    break;  //财务确认订单退款
                    //'finance_purchase_refund':'采购退款待定',
                    //'finance_purchase_payment':'采购付款待定',

                case "workorder_add":
                    data = {
                        title:'新建工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:'',
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //新建工单
                case "workorder_relate":
                    data = {
                        title:'关联工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:'',
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //关联工单

                case "workorder_feedback_start":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`${log.content.processing_name}已开始实施`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单开始
                case "workorder_depart":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`${log.content.processing_name}已出发`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单实施人出发
                case "workorder_feedback_end":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`${log.content.processing_name}已实施完成`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单实施人结束
                case "workorder_close":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`已关闭`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单关闭
                case "workorder_finish":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`已结单`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单结单
                case "workorder_evaluate":
                    data = {
                        title:'工单：',
                        handle_type:'work_order_detail',
                        relate_num:log.relate_num,
                        content_text:`已评价`,
                        info:{id:log.relate_id, work_order_num:log.relate_num}
                    }
                    break; //工单评价


                case "approval_relate":
                    data = {
                        title:`${log.user?.name}关联${log.content?.approval_set_name}，审批编号`,
                        handle_type:'approval_detail',
                        relate_num:`ID：${log.relate_id}`,
                        content_text:'',
                        info:{approval_id:log.relate_id}
                    }
                    break; //关联审批
                case "approval_add":
                    data = {
                        title:`${log.user?.name}发起${log.content?.approval_set_name}，审批编号`,
                        handle_type:'approval_detail',
                        relate_num:`ID：${log.relate_id}`,
                        content_text:'',
                        info:{approval_id:log.relate_id}
                    }
                    break; //新建审批

                default:
                    data = {
                        title:`${log.user?.name}`,
                        handle_type:'',
                        relate_num:`${log.relate_num}`,
                        content_text:'',
                        info:{relate_id:log.relate_id}
                    }
                    break;
            }
            return data
        },
    },
}
</script>

<style  lang="scss" scoped>
@import "@/styles/m_style/project_management.scss";
</style>